module.exports = __webpack_public_path__ + "img/wechat.977baa24.png";